module.exports = __webpack_public_path__ + "img/iraq.c3104587.svg";